import axios from 'axios'

const httpHelper = {};
// 配置Vue插件
httpHelper.install = function fn(Vue) {
    axios.defaults.baseURL = 'http://api.rujiaowang.net/index.php';
    // 添加请求拦截器
    axios.interceptors.request.use(function(config) {
        config.headers.common['Content-Type'] = 'application/json';
        if (config.data && config.url != 'http://test.rujiaowang.net/api/Appteacher/class_app_control') {
            const formData = new FormData();
            Object.keys(config.data).forEach((key) => {
                formData.append(key, config.data[key]);
            });
            config.data = formData;
        }
        return config;
    })
    Vue.prototype.$http = axios
};

export default httpHelper


// WEBPACK FOOTER //
// ./src/plugins/http.js